import React, { useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '@/components/Hero';
import Header from '@/components/Header';

import MobileWhatsAppCTA from '@/components/MobileWhatsAppCTA';
import LazySection from '@/components/LazySection';
import Benefits from '@/components/Benefits';
import PainSection from '@/components/PainSection';
import SolutionSection from '@/components/SolutionSection';
import Testimonials from '@/components/Testimonials';
import AboutTaxHealth from '@/components/AboutTaxHealth';
import RestitutionSection from '@/components/RestitutionSection';
import SavingsComparison from '@/components/SavingsComparison';
import TargetAudience from '@/components/TargetAudience';
import ServicesSection from '@/components/ServicesSection';
import ContabilidadeSection from '@/components/ContabilidadeSection';
import ProcessSection from '@/components/ProcessSection';
import FAQ from '@/components/FAQ';
import BlogHighlights from '@/components/BlogHighlights';
import FinalCTA from '@/components/FinalCTA';
import Footer from '@/components/Footer';

import { initWhatsAppSettings } from '@/utils/whatsapp/whatsAppSettings';

const Index: React.FC = () => {
  const calculatorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    initWhatsAppSettings();
  }, []);

  const scrollToCalculator = () => {
    calculatorRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Helmet>
        <title>Equiparação Hospitalar para Médicos e Clínicas | Tax Health</title>
        <meta name="description" content="Reduza até 70% de impostos com equiparação hospitalar. Restitua até 60 meses, sem ação judicial, 100% remoto. Calcule sua economia agora." />
        <link rel="canonical" href="https://taxhealth.com.br/" />
        <meta property="og:title" content="Equiparação Hospitalar para Médicos e Clínicas | Tax Health" />
        <meta property="og:description" content="Reduza até 70% de impostos com equiparação hospitalar. Restitua até 60 meses, 100% remoto." />
        <meta property="og:url" content="https://taxhealth.com.br/" />
        <meta property="og:type" content="website" />
      </Helmet>
      <Header />
      

      <main id="main" className="flex-grow pt-14 md:pt-16 pb-24 md:pb-0">
        <Hero scrollToCalculator={scrollToCalculator} />
        <Benefits />
        <LazySection minHeight={500}><PainSection /></LazySection>
        <LazySection minHeight={500}><SolutionSection /></LazySection>
        <LazySection minHeight={700}><Testimonials /></LazySection>
        <LazySection minHeight={500}><AboutTaxHealth /></LazySection>
        <LazySection minHeight={500}><RestitutionSection /></LazySection>
        <LazySection minHeight={600}><SavingsComparison /></LazySection>
        <LazySection minHeight={500}><TargetAudience /></LazySection>
        <LazySection minHeight={500}><ServicesSection /></LazySection>
        <LazySection minHeight={700}><ContabilidadeSection /></LazySection>
        <LazySection minHeight={500}><ProcessSection /></LazySection>
        <LazySection minHeight={600}><FAQ /></LazySection>
        <LazySection minHeight={500}><BlogHighlights /></LazySection>
        <LazySection minHeight={400}><FinalCTA /></LazySection>
      </main>

      <Footer />
      <MobileWhatsAppCTA />
    </div>
  );
};

export default Index;
